import type { TellescopeFormFieldBaseProps, TellescopeFieldResponse } from "../../types";
import { AppointmentBookingFieldContent } from "./AppointmentBookingFieldContent";
import { Label } from "@tellescope/ui";
import { SupportedSession } from "@tellescope/tanstack-query";
import { FieldDescription } from "../../FieldDescription";

export interface AppointmentBookingFieldProps extends TellescopeFormFieldBaseProps<"Appointment Booking"> {
  session: SupportedSession;
  enduserId: string;
  userIds?: string[];
  portalURL?: string;
  organizationSubdomain?: string;
  priorResponses?: TellescopeFieldResponse[];
}

export const AppointmentBookingField = ({
  title,
  description,
  htmlDescription,
  required,
  ...rest
}: AppointmentBookingFieldProps) => {
  return (
    <div className="space-y-1">
      {!!title && <Label required={required}>{title}</Label>}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <AppointmentBookingFieldContent {...rest} />
    </div>
  );
};
